import { render, staticRenderFns } from "./user-administration-list.vue?vue&type=template&id=1c8cf860&scoped=true&"
import script from "./user-administration-list.vue?vue&type=script&lang=ts&"
export * from "./user-administration-list.vue?vue&type=script&lang=ts&"
import style0 from "./user-administration-list.vue?vue&type=style&index=0&id=1c8cf860&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8cf860",
  null
  
)

export default component.exports